<template>
  <Form ref="form" :validation-schema="schema">

    <div class="candidature-group-sub">
      <h2>Stage principal</h2>
      <div id="debut-date-anchor" class="candidature-condition candidature-condition-col row">
        <div class="candidature-condition-text">Date de début*</div>
        <Field :value="debutDate" @input="$emit('update:debutDate', $event)" :min="minimumStageDate" class="form-control" name="debutDate" type="date"/>
        <ErrorMessage class="error-feedback" name="debutDate"/>
      </div>

      <div id="end-date-anchor" class="candidature-condition candidature-condition-col row">
        <div class="candidature-condition-text">Date de fin*</div>
        <Field :value="endDate" @input="$emit('update:endDate', $event)" :min="minimumStageDate" class="form-control" name="endDate" type="date"/>
        <ErrorMessage class="error-feedback" name="endDate"/>
      </div>

      <div id="total-duration1-anchor" class="candidature-condition candidature-condition-col row">
        <label class="candidature-condition-text" for="duration">Durée totale (en jours)*</label>
        <Field :value="duration" @input="$emit('update:duration', $event)" class="form-control" name="duration" placeholder="" type="text"/>
        <ErrorMessage class="error-feedback" name="duration"/>
      </div>

      <div class="candidature-condition candidature-condition-col row">
        <label class="candidature-condition-text" for="nameField">Nom et adresse de la structure vétérinaire*</label>
        <Field :value="nameVeterinaryStructure" @input="$emit('update:nameVeterinaryStructure', $event)" class="form-control" name="nameVeterinaryStructure" placeholder="" type="text" rows="2" spellcheck="false" as="textarea"/>
        <ErrorMessage class="error-feedback" name="nameVeterinaryStructure"/>

      </div>

      <div id="activity-veterinary1-anchor" class="candidature-condition candidature-condition-col row">
        <label class="candidature-condition-text" for="nameField">Activité vétérinaire principale*</label>
        <Field :value="activityVeterinaryStructure" @input="$emit('update:activityVeterinaryStructure', $event)" as="select" class="form-control" name="activityVeterinaryStructure">
          <option disabled value=""></option>
          <option value="Animaux de compagnie">Animaux de compagnie</option>
          <option value="Chevaux">Chevaux</option>
          <option value="Animaux de production">Animaux de production</option>
          <option value="Autres">Autres</option>
        </Field>
        <ErrorMessage class="error-feedback" name="activityVeterinaryStructure"/>
      </div>

      <div id="phone-number1-anchor" class="candidature-condition candidature-condition-col row">
        <label class="candidature-condition-text" for="nameField">Téléphone de la structure*</label>
        <Field :value="phoneNumberVeterinaryStructure" @input="$emit('update:phoneNumberVeterinaryStructure', $event)" class="form-control" name="phoneNumberVeterinaryStructure" placeholder="Téléphone*" type="text"/>
        <ErrorMessage class="error-feedback" name="phoneNumberVeterinaryStructure"/>
      </div>

      <div class="candidature-condition candidature-condition-col row">
        <div class="candidature-group">
          <h1><img src="@/assets/img/underline.png" alt="PIÈCE JUSTIFICATIVE"> PIÈCE JUSTIFICATIVE </h1>

          <label :id="'trainingcheck-anchor'+index" class="candidature-condition" :for="'trainingCertificate'+index">
            <input :id="'trainingCertificate'+index" :name="'trainingCertificate'+index" accept="application/msword, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, image/jpeg, image/png" class="candidature-input-file" type="file"
                   @change="fileChange($event.target.name, $event.target.files , 'training'+index);">
            <div class="candidature-button">
              <div class="candidature-button-content">
                <div>
                  <div v-if="fileCheck" class="candidature-button-icon"><img src="@/assets/img/check.png"></div>
                  <div v-else class="candidature-button-icon"><img src="@/assets/img/plus.png"></div>
                </div>
                <div class="candidature-button-content-label">Attestation stage d'immersion n°1<br><a :id="'training' +index" :href="attestationUrl" target=”_blank”>{{ attestationName }}</a></div>
              </div>
            </div>
          </label>

          <Field id="fileCheck" ref="fileCheck" :value="fileCheck" @input="$emit('update:fileCheck', $event)" class="form-control" name="fileCheck" placeholder=""
                 style="visibility:hidden; height:0;"
                 type="text"
          />
          <ErrorMessage class="error-feedback" name="fileCheck"/>
        </div>

      </div>


    </div>


  </Form>

</template>

<script>
import {ErrorMessage, Field, Form} from "vee-validate";
import * as yup from "yup";
import {simulateNewfiles} from "@/services/fake-href.service";


export default {
  name: "Stage",
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  props: {
    index: Number,
    debutDate: String,
    endDate: String,
    duration: [String, Number],
    nameVeterinaryStructure: String,
    activityVeterinaryStructure: String,
    phoneNumberVeterinaryStructure: String,
    trainingcheck: Boolean,
    attestationName: String,
    attestationUrl: String,

  },
  emits: [
    'update:debutDate',
    'update:endDate',
    'update:duration',
    'update:nameVeterinaryStructure',
    'update:activityVeterinaryStructure',
    'update:phoneNumberVeterinaryStructure',
    'update:fileCheck'
  ],
  data() {
    return {
      fileCheck: this.trainingcheck,
      fileList: []
    };
  },


  methods: {
    fileChange(fieldName, fileList, id) {

      if (!fileList.length) {
        return;
      }
      const allowedTypes = document.getElementById(fieldName).accept.split(',').map(type => `${type.trim()}`);
      if (!allowedTypes.includes(fileList[0].type)) {
        alert(`Le type de fichier n\'est pas autorisé`)
        return;
      }
      if (fileList[0]['size'] > (8 * 1000 * 1024)) {
        alert('Le fichier ne doit pas être supérieur à 8Mo')
        return;
      }


      simulateNewfiles(fileList[0], id);
      this.fileCheck = true;
      this.fileList = fileList;

    },
  },

  computed: {
    minimumStageDate() {
      const date = new Date();
      date.setFullYear(date.getFullYear() - 2);
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${date.getFullYear()}-${month}-${day}`;
    },

    schema() {
      return yup.object().shape({
        debutDate: yup
            .date()
            .required("Ce champ doit être renseigné")
            .test('custom-validation', "Ce champ doit être renseigné", (value) => {
              return true;
            })
            .min('01/01/1900', "La date est invalide")
            .min(this.minimumStageDate, "Votre stage doit dater de moins de 2 ans")
            .max('01/01/2100', "La date est invalide")
            .typeError("Veuillez entrer uniquement des chiffres")
            .default(() => new Date())

        ,
        endDate: yup
            .date()
            .required("Ce champ doit être renseigné")
            .min('1900-01-01', "La date est invalide")
            .min(this.minimumStageDate, "Votre stage doit dater de moins de 2 ans")
            .max('2100-01-01', "La date est invalide")
            .typeError("Veuillez entrer une date valide")
            .test(
                "end-date-after-start",
                "La date de fin doit-être supérieure à la date de début",
                function(value) {
                  // Utiliser this.parent pour accéder aux autres valeurs du même formulaire
                  if (!this.parent || !this.parent.debutDate || !value) return true;
                  return new Date(value) > new Date(this.parent.debutDate);
                }
            ),
        duration: yup
            .number()
            .required("Ce champ doit être renseigné")
            .typeError("Veuillez renseigner un nombre de jours"),
        activityVeterinaryStructure: yup
            .string()
            .required("Ce champ doit être renseigné")
            .test('custom-validation', "Ce champ doit être renseigné", (value) => {
              return true;
            }),
        nameVeterinaryStructure: yup
            .string()
            .required("Ce champ doit être renseigné")
            .test('custom-validation', "Ce champ doit être renseigné", (value) => {
              return true;
            }),
        phoneNumberVeterinaryStructure: yup
            .string()
            .matches(/^(((\+)33|0|0033)[1-9](\d{2}){4})|((00262|\+262)((\d{2}){3}))$/, "Le numéro de téléphone n'est pas valide")
            .required("Le numéro de téléphone est nécessaire")
            .test('custom-validation', "Ce champ doit être renseigné", (value) => {
              return true;
            }),
        fileCheck: yup
            .string()
            .test(
                'file-check',
                "Attestation : Ce champ doit être renseigné",
                (value) => {
                  if (this.moduleType !== 'Stage') return true;
                  return value === 'true' || this.fileCheck === true || this.fileList.length > 0;
                }
            )
      })
    },

  }
}
</script>
